(() => {
  if (window.nhCartTouchScroll) return;
  window.nhCartTouchScroll = true;
  let gesture = null;
  let frame = 0;
  let suppressClickUntil = 0;
  let lastScroller = null;
  const stopMomentum = () => {
    cancelAnimationFrame(frame);
    frame = 0;
  };
  const clamp = (element, position) => Math.max(0, Math.min(position, element.scrollHeight - element.clientHeight));
  const startMomentum = (state) => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let velocity = state.velocity;
    let previous = performance.now();
    const tick = (now) => {
      if (!state.element.isConnected) return;
      const elapsed = Math.min(now - previous, 32);
      previous = now;
      velocity *= Math.exp(-elapsed / 180);
      const before = state.element.scrollTop;
      state.element.scrollTop = clamp(state.element, before + velocity * elapsed);
      if (Math.abs(velocity) > 0.025 && Math.abs(state.element.scrollTop - before) > 0.1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
  };
  window.addEventListener('touchstart', (event) => {
    stopMomentum();
    gesture = null;
    if (event.touches.length !== 1 || !(event.target instanceof Element)) return;
    const element = event.target.closest('#slidecarthq .slidecarthq .items');
    if (!element || element.scrollHeight <= element.clientHeight + 1) return;
    if (event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
    const touch = event.touches[0];
    gesture = { element, id: touch.identifier, x: touch.clientX, y: touch.clientY, lastY: touch.clientY, top: element.scrollTop, time: performance.now(), velocity: 0, dragging: false };
  }, { capture: true, passive: true });
  window.addEventListener('touchmove', (event) => {
    if (!gesture || event.touches.length !== 1) { gesture = null; return; }
    const touch = event.touches[0];
    if (touch.identifier !== gesture.id || !gesture.element.isConnected) { gesture = null; return; }
    const distance = gesture.y - touch.clientY;
    if (!gesture.dragging) {
      if (Math.abs(distance) < 5) return;
      if (Math.abs(touch.clientX - gesture.x) > Math.abs(distance)) { gesture = null; return; }
      gesture.dragging = true;
    }
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
    const now = performance.now();
    const elapsed = Math.max(8, now - gesture.time);
    gesture.velocity = Math.max(-2.5, Math.min(2.5, (gesture.lastY - touch.clientY) / elapsed));
    gesture.lastY = touch.clientY;
    gesture.time = now;
    gesture.element.scrollTop = clamp(gesture.element, gesture.top + distance);
  }, { capture: true, passive: false });
  const finish = (event) => {
    const state = gesture;
    gesture = null;
    if (!state?.dragging) return;
    suppressClickUntil = performance.now() + 450;
    lastScroller = state.element;
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
    if (event.type === 'touchend' && performance.now() - state.time < 80) startMomentum(state);
  };
  window.addEventListener('touchend', finish, { capture: true, passive: false });
  window.addEventListener('touchcancel', finish, { capture: true, passive: false });
  window.addEventListener('click', (event) => {
    if (performance.now() < suppressClickUntil && lastScroller?.contains(event.target)) {
      event.preventDefault();
      event.stopPropagation();
      suppressClickUntil = 0;
    }
  }, true);
})();
